"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var classNames = require("classnames");
var React = require("react");
var moment = require("moment");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var utils_1 = require("../utils");
exports.ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var row = data.items[index];
    var selected = row.type === 'USER'
        ? data.selectedUsers.findIndex(function (item) {
            return item.user.id === row.user.id && item.group.id === row.group.id;
        }) > -1
        : data.selectedGroups.findIndex(function (item) { return item.id === row.group.id; }) > -1;
    var isDeleteColumnVisible = !data.isDeleteColumnHidden &&
        (row.type === 'USER' ? data.deleteUsers : data.deleteGroup) !==
            undefined &&
        row.removeAllowed;
    var isEditColumnVisible = !data.isEditColumnHidden &&
        (row.type === 'USER' ? data.openUserSettingsModal : data.editGroup) !==
            undefined &&
        row.editAllowed;
    return (React.createElement("div", { className: classNames('row', row.type.toLowerCase()), style: style },
        React.createElement("div", { className: 'row__column icons' },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', className: selected ? 'selected' : '', circle: true, onClick: function () {
                    if (row.type === 'USER') {
                        data.setUsersSelected([row], !selected);
                    }
                    else {
                        data.setGroupsSelected([row.group], !selected);
                    }
                } })),
        React.createElement("div", { className: "row__column indent-".concat(row.indent, " ").concat(row.type.toLowerCase()) }),
        row.type === 'USER' ? (React.createElement("div", { className: 'row__column narrow' })) : (React.createElement("div", { className: 'row__column narrow group-expander', onClick: function () {
                return data.collapseUserRow([row.group.id], !data.isCollapsed.includes(row.group.id));
            } },
            React.createElement(sok_ui_1.Icon, { className: data.isCollapsed.includes(row.group.id)
                    ? 'fa-chevron-down'
                    : 'fa-chevron-up' }))),
        React.createElement("div", { className: 'row__column narrow icon-column' }, (0, utils_1.getIcon)(row)),
        React.createElement("div", { className: 'row__column __user' }, row.type === 'USER' ? (React.createElement("div", { className: 'user-row' },
            React.createElement("div", { className: 'user-info' },
                React.createElement("div", { className: 'userName' },
                    row.user.firstName,
                    " ",
                    row.user.lastName),
                React.createElement("div", { className: 'userEmail' },
                    " ",
                    row.user.email,
                    " ")),
            row.user.status === 'FIRST_TIME' && (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, "".concat(row.user.email, " ").concat((0, translation_1.getLocalization)('userfront/project/teamMembers/userHasNotAcceptedInvitation')),
                    ' ') },
                React.createElement(components_1.TableRowIcon, { icon: 'fa-exclamation-square fa-1x', className: 'tooltip-icon user-not-accepted-terms' }))))) : ((0, utils_1.getGroupName)(row.group))),
        React.createElement("div", { className: "row__column fill-".concat(2 - row.indent, " ").concat(row.type.toLowerCase()) }),
        React.createElement("div", { className: 'row__column __company' }, row.type === 'USER' ? row.user.company : ''),
        React.createElement("div", { className: 'row__column __description' }, row.type === 'GROUP' || row.type === 'CATEGORY'
            ? row.group.description
            : ''),
        React.createElement("div", { className: 'row__column __validity' }, !data.isValidityColumnHidden &&
            row.group.validUntil !== undefined && (React.createElement(sok_ui_1.Tooltip, { content: row.group.validUntil >= Date.now() ? (React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfileValidityStillValid') +
                ' ' +
                moment(new Date(row.group.validUntil)).format('DD.MM.YYYY HH:mm'))) : (React.createElement("span", null,
                React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfileValidityNotValid') +
                    ' ' +
                    moment(new Date(row.group.validUntil)).format('DD.MM.YYYY HH:mm')))) },
            React.createElement(sok_ui_1.Icon, { prefix: 'far', className: row.group.validUntil >= Date.now()
                    ? 'fas fa-calendar-check check-color'
                    : 'fas fa-calendar-times times-color' })))),
        React.createElement("div", { className: 'row__column __edit' }, isEditColumnVisible && (React.createElement(components_1.TableRowIcon, { icon: 'fa-cog', className: 'black', circle: true, onClick: function () {
                if (row.type === 'USER') {
                    data.openUserSettingsModal &&
                        data.openUserSettingsModal(row.user);
                }
                else {
                    data.editGroup && data.editGroup(row.group);
                }
            } }))),
        React.createElement("div", { className: 'row__column __remove' }, isDeleteColumnVisible && (React.createElement(components_1.TableRowIcon, { icon: 'fa-times', circle: true, className: 'red', onClick: function () {
                if (row.type === 'USER') {
                    data.setWarningModal({
                        title: (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDelete'),
                        content: [
                            (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDeleteUser'),
                            (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDeleteUserSpecification', [
                                row.user.firstName || '',
                                row.user.lastName || '',
                                row.user.email
                            ])
                        ],
                        action: function () {
                            return data.deleteUsers && data.deleteUsers(row.group, row.user);
                        }
                    });
                }
                else {
                    data.setWarningModal({
                        title: (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDelete'),
                        content: [
                            (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDeleteUserProfile'),
                            (0, translation_1.getLocalization)('userfront/project/teamMembers/confirmDeleteUserProfileSpecification', [row.group.name])
                        ],
                        action: function () {
                            return data.deleteGroup && data.deleteGroup(row.group);
                        }
                    });
                }
            } }))),
        React.createElement("div", { className: 'row__column narrow' })));
});
